import React, { useEffect, useState, useId } from 'react'

import MenuCard from './MenuCard'
import { ISearchContent, ILanguageContent, LINK_STYLE_ENUM } from '../../models'

function MenuSearch({
  searchContent,
  languageItems,
  onOpen,
}: {
  searchContent: ISearchContent
  languageItems: ILanguageContent[]
  // eslint-disable-next-line @typescript-eslint/ban-types
  onOpen?: Function
}) {
  const [open, setOpen] = useState(false)
  const [searchPath, setSearchPath] = useState('')
  const [searchText, setSearchText] = useState('')

  const formId = useId()

  useEffect(() => {
    const route = location.pathname
    const origin = location.origin
    languageItems.forEach((item) => {
      if (route.includes(item.Url)) {
        setSearchPath(origin + item.Url + '/search')
      } else {
        setSearchPath(origin + '/search')
      }
    })
  }, [])

  const onSubmit = (e) => {
    e.preventDefault()
    if (searchText.length > 0)
      window.open(`${searchPath}?q=${searchText}`, '_self')
  }

  const handleOpen = (status: boolean) => {
    const scrollWidth = window.innerWidth - document.documentElement.clientWidth
    const body = document.body
    const searchBtn = document.getElementById('searchBtn')

    if (status) {
      body.classList.add('overflow-y-hidden')
      body.style.paddingRight = `${scrollWidth}px`
      if (searchBtn && window.innerWidth < 1440 && window.innerWidth >= 1024) {
        searchBtn.style.marginRight = `${scrollWidth}px`
      }
    } else {
      if (searchBtn && window.innerWidth < 1440 && window.innerWidth >= 1024) {
        searchBtn.style.marginRight = '0'
      }
      body.style.paddingRight = '0'
      body.classList.remove('overflow-y-hidden')
    }

    setOpen(status)

    if (onOpen) {
      onOpen(status)
    }
  }

  return (
    <div id="searchBtn">
      <search className="flex items-center ">
        <button
          className={`btn btn-circle-small btn-search z-50 relative `}
          onClick={() => {
            !open && handleOpen(true)
          }}
          form={formId}
          type={open ? 'submit' : 'button'}
        ></button>

        {open && (
          <>
            <div className="fixed  w-screen h-[calc(100dvh-80px)] xl:h-screen flex justify-end left-0 top-0 z-[49] shadow -mx-[calc((100vw-100%)/2)] mt-[81px] md:mt-0 ">
              <div className="bg-black opacity-40 flex-1  z-[49] "></div>

              <div
                className=" bg-white w-full h-[calc(100dvh-80px)] xl:h-screen opacity-100 pb-[16px] md:pb-[21px]  items-center z-[49] overflow-y-auto
            md:w-[602px] xl:w-[546px]"
              >
                <div
                  className="flex  sticky flex-row items-center  justify-between px-4 w-full top-0 bg-white pt-[16px] md:pt-[21px]
               md:px-10 md:pr-[79px]
               xl:px-10
              "
                >
                  <form
                    id={formId}
                    className="flex gap-[6px] flex-row items-center w-full mb-0 "
                    onSubmit={(e) => onSubmit(e)}
                  >
                    <input
                      className="appearance-none border-b-2 border-engineering-grey-1 py-2 px-3 w-full leading-tight focus:outline-none focus:shadow-outline 
 "
                      type="text"
                      placeholder={searchContent.PlaceholderText}
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                    <div className="w-[100px] md:w-[160px]"></div>
                  </form>

                  <button onClick={() => handleOpen(false)}>
                    <div className="flex gap-[6px] flex-row items-center">
                      <span>{searchContent.CloseButtonText}</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M3.36719 3.37109L16.6254 16.6293"
                          stroke="#33333C"
                          stroke-width="2"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M16.6328 3.37109L3.37456 16.6293"
                          stroke="#33333C"
                          stroke-width="2"
                          stroke-miterlimit="10"
                        />
                      </svg>
                    </div>
                  </button>
                </div>
                <div
                  className="flex flex-col py-16 gap-3 border-b-separator px-4
              md:px-10
              "
                >
                  <h4>{searchContent.PopularSearchTitle}</h4>
                  <div className="flex flex-col gap-3">
                    {searchContent.PopularSearchTerms.map((term) => (
                      <div key={term}>
                        <a
                          className="link link-text"
                          href={`${searchPath}?q=${term}`}
                        >
                          {term}
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
                <div
                  className="px-4 grid gap-7 py-7 grid-cols-1
              md:grid-cols-2 md:px-10"
                >
                  {searchContent.ChallengeHighlights.map(
                    (challengeHighlight) => (
                      <MenuCard
                        heading={challengeHighlight.Heading}
                        text={challengeHighlight.Teaser}
                        imageUrl={challengeHighlight.ImageUrl}
                        link={challengeHighlight.Link}
                        linkStyle={LINK_STYLE_ENUM.CHEVRON}
                        key={challengeHighlight.Heading}
                      />
                    )
                  )}
                </div>
              </div>
              <div className=" bg-white z-[49] xl:w-[calc((100vw-1440px)/2)] hidden xl:block ml-[-1px]"></div>
            </div>
          </>
        )}
      </search>
    </div>
  )
}

export default MenuSearch
